import { GpsFixed, LocationOn, Visibility } from "@mui/icons-material";
import { Box, Card, IconButton, Typography } from "@mui/material";
import { Column } from "components/common/Layout/Column";
import { Row } from "components/common/Layout/Row";
import dayjs from "dayjs";
import { Ride } from "types/Ride";
import { toCurrencyFormat } from "utils/formatter";

type Props = {
  ride: Ride;
  onClick: (ride: Ride) => void;
  onEyeClick: () => void;
};

const RideCard = ({ ride, onClick, onEyeClick }: Props) => {
  const { driverOffer } = ride;
  const { vehicleType } = driverOffer.travelOffer;
  let currentStatusMessage: string = "";
  switch (ride.status) {
    case "pickup":
      currentStatusMessage = "Recogiendo pasajero";
      break;
    case "in_progress":
      currentStatusMessage = "En ruta";
      break;
    case "completed":
      currentStatusMessage = "Viaje completado";
      break;
    case "cancelled":
      currentStatusMessage = "Viaje cancelado";
      break;
  }
  return (
    <Card sx={{ padding: 2 }}>
      <Box flex={1} display="flex" onClick={() => onClick && onClick(ride)}>
        <Column flex={1}>
          <Row>
            <Column flex={1} gap={1}>
              {driverOffer.travelOffer.user.name}
              <Row gap={0.5}>
                <GpsFixed fontSize="small" />
                {driverOffer.travelOffer.originAddress}
              </Row>
              <Row gap={0.5}>
                <LocationOn fontSize="small" />
                {driverOffer.travelOffer.destinationAddress}
              </Row>
            </Column>
            <Column flex={1} alignItems={"center"}>
              <img
                src={vehicleType.icon}
                width={44}
                height={44}
                style={{
                  objectFit: "contain",
                }}
              />
              {vehicleType.type}
              <Box>{driverOffer.transportDriver?.user.name}</Box>
            </Column>
            <Column justifyContent="center" alignItems="center">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onEyeClick();
                }}
              >
                <Visibility fontSize="large" />
              </IconButton>
            </Column>
          </Row>
          <Typography variant="h6">{currentStatusMessage}</Typography>
          <Row alignItems="center" justifyContent="space-between">
            <Typography variant="subtitle2" color="primary">
              {dayjs(ride.updatedAt).format("DD/MM/YYYY hh:mm a")}
            </Typography>
            <Typography variant="h6" color="primary">
              Tarifa: {toCurrencyFormat(driverOffer.travelOffer.price)}
            </Typography>
          </Row>
        </Column>
      </Box>
    </Card>
  );
};

export default RideCard;
